export default "__VITE_ASSET__DStCRMn$__"